/**
 * RadialGauge — one of 5 cockpit loader variants.
 * Ported from landing/components/cockpit/loaders/RadialGauge.tsx.
 */

const RADIUS = 90;
const STROKE_WIDTH = 6;
const CENTER = 110;
const TICK_COUNT = 20;

const TICKS = Array.from({ length: TICK_COUNT + 1 }).map((_, i) => {
  const angle = Math.PI + (i / TICK_COUNT) * Math.PI;
  const innerR = RADIUS - 12;
  const outerR = RADIUS - 4;
  return {
    x1: CENTER + innerR * Math.cos(angle),
    y1: CENTER + innerR * Math.sin(angle),
    x2: CENTER + outerR * Math.cos(angle),
    y2: CENTER + outerR * Math.sin(angle),
    threshold: (i / TICK_COUNT) * 100,
  };
});

const CIRCUMFERENCE = Math.PI * RADIUS;

interface Props {
  progress: number;
}

export default function RadialGauge({ progress }: Props) {
  const offset = CIRCUMFERENCE - (progress / 100) * CIRCUMFERENCE;

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4">
      <div className="relative" style={{ width: 220, height: 130 }}>
        <svg width={220} height={130} viewBox="0 0 220 130" className="overflow-visible">
          {TICKS.map((tick, i) => {
            const isActive = tick.threshold <= progress;
            return (
              <line
                key={i}
                x1={tick.x1} y1={tick.y1} x2={tick.x2} y2={tick.y2}
                stroke={isActive ? 'var(--color-orange)' : 'var(--color-border)'}
                strokeWidth={1.5}
                opacity={isActive ? 1 : 0.4}
              />
            );
          })}
          <path
            d={`M ${CENTER - RADIUS} ${CENTER} A ${RADIUS} ${RADIUS} 0 0 1 ${CENTER + RADIUS} ${CENTER}`}
            fill="none"
            stroke="var(--color-surface-muted)"
            strokeWidth={STROKE_WIDTH}
            strokeLinecap="round"
          />
          <path
            d={`M ${CENTER - RADIUS} ${CENTER} A ${RADIUS} ${RADIUS} 0 0 1 ${CENTER + RADIUS} ${CENTER}`}
            fill="none"
            stroke="var(--color-orange)"
            strokeWidth={STROKE_WIDTH}
            strokeLinecap="round"
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={offset}
            style={{
              filter: 'drop-shadow(0 0 6px oklch(from var(--color-orange) l c h / 0.4))',
            }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-1">
          <div className="font-mono text-[48px] font-bold leading-none text-txt-primary tabular-nums">
            {Math.round(progress)}
          </div>
          <div className="font-mono text-[11px] text-txt-tertiary mt-1 tracking-wider">
            Credia
          </div>
        </div>
      </div>
    </div>
  );
}
